import type { SvgComponent } from '@/types/SvgComponent';

export const LinkIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path d="M9 15L15 9" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.5 7.13523L13.3181 4.32273C14.1644 3.49017 15.3053 3.02572 16.4924 3.03055C17.6795 3.03539 18.8166 3.50911 19.6561 4.34854C20.4955 5.18796 20.9692 6.32508 20.974 7.51219C20.9789 8.69931 20.5144 9.84025 19.6819 10.6865L16.8638 13.4999"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.13547 10.5L4.32297 13.3181C3.49041 14.1644 3.02597 15.3053 3.0308 16.4924C3.03563 17.6795 3.50936 18.8166 4.34878 19.6561C5.18821 20.4955 6.32532 20.9692 7.51244 20.974C8.69955 20.9789 9.84049 20.5144 10.6867 19.6819L13.5002 16.8638"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
